import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  TextField,
  makeStyles,
  Typography,
  Select,
  MenuItem,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";

/* ------------------------- Importaciones internas ------------------------- */
import { cancelButton, saveButton } from "../../../../core/styles/ui.constants";
import BotonGenerico from "../../../../components/Button/Button";
import DialogFooter from "../../../../components/DialogFooter/DialogActions";

/* --------------------------------- Estilos -------------------------------- */
const useStyles = makeStyles((theme) => ({
  dialogContent: {
    padding: theme.spacing(4),
    minWidth: "600px",
  },
  confirmButton: { ...saveButton, marginTop: theme.spacing(1) },
  cancelarButton: { ...cancelButton, marginTop: theme.spacing(1) },
  closeButton: {
    position: "absolute",
    top: theme.spacing(1),
    right: theme.spacing(1),
  },
  titleText: {
    textAlign: "center",
  },
  formRow: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: theme.spacing(1), // Espacio más amplio entre las filas
    gap: theme.spacing(2), // Espacio entre los elementos de cada fila
  },
  field: {
    width: "60%", // Ajuste para que los campos no se monten
    fontSize: "0.6rem", // Tamaño de fuente moderado
    textTransform: "none",
    marginBottom: theme.spacing(1), // Espacio entre campos en la misma fila
  },
}));

const FirmaComprobanteModal = ({ open, onClose, onSubmit }) => {
  const classes = useStyles();
  const [openConfirm, setOpenConfirm] = useState(false);
  const [openInfo, setOpenInfo] = useState(false);
  // const [info, setInfo] = useState("");

  const initialState = {
    fechaPago: new Date().toISOString().split("T")[0],
    nroReferenciaPago: "",
    modalidadPago: "",
  };

  const [state, setState] = useState(initialState);
  const [errors, setErrors] = useState({});

  // Cuando se abre desde el padre, abrimos confirmación
  useEffect(() => {
    if (open) {
      setOpenConfirm(true);
    } else {
      setOpenConfirm(false);
      setOpenInfo(false);
      setState(initialState);
      setErrors({});
    }
  }, [open]);

  const handleConfirm = () => {
    setOpenConfirm(false);
    setOpenInfo(true);
  };

  const handleCancel = () => {
    setOpenConfirm(false);
    close(); // avisamos al padre que cerró
  };

  const validarDatos = () => {
    const newErrors = {};
    if (!state.nroReferenciaPago)
      newErrors.nroReferenciaPago = "El nro de referencia es obligatorio.";

    if (!state.modalidadPago)
      newErrors.modalidadPago = "La modalidad de pago es obligatoria.";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleInfoSubmit = () => {
    const validacion = validarDatos();
    if (!validacion) return;

    if (onSubmit) {
      const submitInfo = {
        ...state,
        estado: "Firmado",
      };
      onSubmit(submitInfo); // devolvemos la info al padre
    }

    setOpenInfo(false);
    close();
  };

  const close = () => {
    setState(initialState);
    setOpenConfirm(false);
    setOpenInfo(false);
    setErrors({});
    onClose();
  };

  return (
    <>
      {/* Modal de confirmación */}
      <Dialog open={openConfirm} onClose={handleCancel}>
        <DialogTitle disableTypography>
          <Typography variant="h6" className={classes.titleText}>
            Confirmar firma
          </Typography>
          <IconButton
            aria-label="close"
            className={classes.closeButton}
            onClick={close}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          ¿Está seguro de que quiere firmar este comprobante?
        </DialogContent>
        <DialogFooter>
          <BotonGenerico
            tipo="guardar"
            color="primary"
            onClick={handleConfirm}
            text="Confirmar"
          />
          <BotonGenerico
            tipo="cancelar"
            color="secondary"
            onClick={handleCancel}
            text="Cancelar"
          />
          {/* <Button
            variant="contained"
            color="primary"
            startIcon={<CheckIcon />}
            className={classes.confirmButton}
            onClick={handleConfirm}
          >
            Confirmar
          </Button>
          <Button
            variant="contained"
            startIcon={<CloseIcon />}
            className={classes.cancelarButton}
            onClick={handleCancel}
          >
            Cancelar
          </Button> */}
        </DialogFooter>
      </Dialog>

      {/* Modal de información */}
      <Dialog open={openInfo} onClose={close}>
        {/* <DialogTitle>Información adicional</DialogTitle> */}
        <DialogTitle disableTypography>
          <Typography variant="h6" className={classes.titleText}>
            Información adicional
          </Typography>
          <IconButton
            aria-label="close"
            className={classes.closeButton}
            onClick={close}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent className={classes.dialogContent}>
          <div className={classes.formRow}>
            <div className={classes.field}>
              <Typography variant="subtitle1">Modalidad de pago</Typography>
              {/* <TextField
                variant="outlined"
                fullWidth
                value={state.modalidadPago}
                onChange={(e) => {
                  const value = e.target.value;
                  setState((prev) => ({ ...prev, modalidadPago: value }));
                }}
              /> */}
              <Select
                variant="outlined"
                fullWidth
                defaultValue={""}
                value={state.modalidadPago || ""}
                onChange={(e) => {
                  const value = e.target.value;
                  setState((prev) => ({ ...prev, modalidadPago: value }));
                }}
                error={!!errors.modalidadPago || undefined}
              >
                <MenuItem value="efectivo">Efectivo</MenuItem>
                <MenuItem value="cheque">Cheque</MenuItem>
                <MenuItem value="transferencia">Transferencia</MenuItem>
                <MenuItem value="otro">Otro</MenuItem>
                {/* Modalidad de pago
                 * Transferencia bancaria
                 * Checke
                 * Efectivo
                 * Otro */}
              </Select>
              {errors.modalidadPago && (
                <Typography color="error" variant="body2">
                  {errors.modalidadPago}
                </Typography>
              )}
            </div>
            <div className={classes.field}>
              <Typography variant="subtitle1">Nro referencia</Typography>
              <TextField
                variant="outlined"
                fullWidth
                value={state.nroReferenciaPago}
                onChange={(e) => {
                  let value = e.target.value;
                  setState((prev) => ({
                    ...prev,
                    nroReferenciaPago: value,
                  }));
                }}
              />
              {errors.nroReferenciaPago && (
                <Typography color="error" variant="body2">
                  {errors.nroReferenciaPago}
                </Typography>
              )}
            </div>
          </div>
        </DialogContent>
        <DialogFooter>
          <BotonGenerico
            tipo="guardar"
            color="primary"
            onClick={handleInfoSubmit}
            text="Guardar"
          />
          <BotonGenerico
            tipo="cancelar"
            color="secondary"
            onClick={close}
            text="Cancelar"
          />
          {/* <Button
            variant="contained"
            color="primary"
            startIcon={<CheckIcon />}
            className={classes.confirmButton}
            onClick={handleInfoSubmit}
          >
            Guardar
          </Button>
          <Button
            variant="contained"
            startIcon={<CloseIcon />}
            className={classes.cancelarButton}
            onClick={close}
          >
            Cancelar
          </Button> */}
        </DialogFooter>
      </Dialog>
    </>
  );
};

export default FirmaComprobanteModal;
